import forOwn from 'lodash-es/forOwn';
import has from 'lodash-es/has';

function isObjLiteral(_obj) {
    var _test = _obj;
    return typeof _obj !== 'object' || _obj === null
        ? false
        : (function () {
              while (!false) {
                  if (Object.getPrototypeOf((_test = Object.getPrototypeOf(_test))) === null) {
                      break;
                  }
              }
              return Object.getPrototypeOf(_obj) === _test;
          })();
}

export default function defaultsDeep<T extends any>(_target: T, ...sources: T[]): T {
    const target = (_target || {}) as T;

    function copy(target: T, current: T) {
        forOwn(current, function (value, key) {
            const val = target[key];
            if (!has(target, key)) {
                target[key] = value;
            } else if (isObjLiteral(val) && isObjLiteral(value)) {
                defaultsDeep(val, value);
            }
        });
    }

    sources.forEach(source => {
        copy(target, source);
    });

    return target as T;
}
